var _localStorage$getItem;

import { atom } from "jotai";
var primitiveTempTestUpdateIdAtom = atom(true ? (_localStorage$getItem = localStorage.getItem("tempTestUpdateId")) !== null && _localStorage$getItem !== void 0 ? _localStorage$getItem : null : null);
export var tempTestUpdateIdAtom = atom(function (get) {
  return get(primitiveTempTestUpdateIdAtom);
}, function (_get, set, newValue) {
  set(primitiveTempTestUpdateIdAtom, newValue);
  window.localStorage.setItem("tempTestUpdateId", newValue);
});